import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from '../api';
import { TodoEntries } from './TodoList';
import { TODO_KEY, type TodoList } from './types';

/** The whole of "Do zrobienia" (`/do-zrobienia`): every entry the user may see, the most urgent first. */
export function TodoPage() {
  const todo = useQuery({ queryKey: TODO_KEY, queryFn: () => api<TodoList>('/api/todo') });
  return (
    <section className="page narrow" aria-labelledby="todo-title" data-feature-id="todo.list">
      <h1 id="todo-title">Do zrobienia{todo.data ? ` (${todo.data.count})` : ''}</h1>
      <p className="muted">Sprawy z całego programu, które czekają: najpierw pilne. Kliknij wpis, żeby to zrobić.</p>
      {todo.isLoading && <p className="muted" role="status">Wczytywanie…</p>}
      {todo.error && <p className="alert" role="alert">{todo.error instanceof ApiError ? todo.error.message : 'Nie udało się wczytać listy'}</p>}
      {todo.data && (todo.data.count === 0 ? <p className="muted">Nic nie czeka. Wszystko zrobione.</p> : <TodoEntries items={todo.data.items} label="Do zrobienia" />)}
    </section>
  );
}
